import store from '../store';
import { checkauth } from '../Helper';

const WebVitals = () => import('../views/webvitals/Index.vue');

// solo per lo staff (admin o "Loggati come"): la voce di menu e' nascosta ai merchant e
// l'indirizzo scritto a mano riporta alla home
const guard = (to, from, next) => {
	checkauth().then(response => {
		if (!response) return next('/login');
		return store.getters['profile/isAdminSession'] ? next() : next('/');
	});
};

export default [{ path: '/ecommerce/speed', name: 'webvitals', component: WebVitals, beforeEnter: guard }];
